import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/26371.jpg';

function CommunityPolicing() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Community Policing and Crime Prevention" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Community Policing and Crime Prevention</h4>
              <p>
                This sub-department focuses on fostering strong relationships between law enforcement and the community to enhance public safety.<br />
                Initiatives include neighborhood watch programs, community engagement events, and educational workshops to raise awareness about crime prevention strategies.<br /><br />
                By working together with community members, we aim to build trust, reduce crime rates, and ensure a safer environment for everyone.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Neighborhood Watch Programs</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Community Engagement Events</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Crime Prevention Workshops</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are committed to building stronger, safer communities through collaboration, transparency, and proactive crime prevention measures.
              </p>
            </div>
            <div>
              <Link to="/department/public-safety">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default CommunityPolicing;